import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ArticleSpecification} from '../../envisia/article/models/article-specification.model';
import {ReactBaseComponent} from '../../react/base/react-base.component';
import {ErpAngularZonedRouterService} from '../../react/components/react-router/erp-angular-zoned-router.service';
import {ErpReactUiRouterContextWrapper} from '../../react/components/react-router/erp-react-ui-router-context-wrapper';
import {MultilayerPlan} from '../../react/multilayer-plan/multilayer-plan';

const containerElementName = 'reactMultilayerPlanContainer';

@Component({
    selector: 'multilayer-plan',
    template: `<div #${containerElementName}></div>`,
    standalone: true,
})
export class MultilayerPlanComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() specification: { [key: string]: ArticleSpecification };

  constructor(private angularRouterService: ErpAngularZonedRouterService) {
    super();
  }

  protected override renderComponent() {
    return <ErpReactUiRouterContextWrapper context={this.angularRouterService.context()}>
      <MultilayerPlan specification={this.specification}/>
    </ErpReactUiRouterContextWrapper>;
  }
}
